import React, { useState, useRef } from 'react';
import musicIcon from '../assets/music.png'; // Add your music icon
import musicFile from '../assets/music.mp3'; // Add your music file
import './MusicPlayer.css';

function MusicPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(musicFile));

  const toggleMusic = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
      audioRef.current.loop = true;
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="music-player">
      <button 
        className={`music-button ${isPlaying ? 'playing' : ''}`}
        onClick={toggleMusic}
      >
        <img 
          src={musicIcon} 
          alt="Music Toggle" 
          className="music-icon"
        />
      </button>
    </div>
  );
}

export default MusicPlayer; 